import React, { Component } from "react";
import { Accordion, Menu } from "semantic-ui-react";
import SubLink from "./sublink";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { dailyPlacementDashboard, FEATURES,isPlacementAnalysisReportEnabled, isDumpAnalysisReportEnabled, isLRDumpReportEnabled, isLrProfitabilityReportEnabled, isMISReportEnabled, isReportsEnabled, isTripDistanceAnalysisReportEnabled, reportNames, reportTitle, SOBReport } from "../../utils/constant";

class AccordionExampleMenu extends Component {
  state = { activeIndex: 0 };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { t } = this.props;
    const { activeIndex } = this.state;
    const customerNo = localStorage.getItem('customerNumber')

    const Masters = (
      <div className="p-0 m-0">
        {this.props.permissions.TA_VENDOR_MASTER &&
          this.props.permissions.TA_VENDOR_MASTER.VIEW == true ? (
          <SubLink subLink={customerNo != 1158 ? t("vendor") : t("partner")} To="/vendor" />
        ) : null}
        {this.props.permissions.TA_VENDOR_SHARE &&
          this.props.permissions.TA_VENDOR_SHARE.VIEW == true ? (
          <SubLink subLink={customerNo != 1158 ? t("vendor_share") : t("partner_share")} To="/vendor-share" />
        ) : null}
        {this.props.permissions.TA_VENDOR_GROUP &&
          this.props.permissions.TA_VENDOR_GROUP.VIEW == true ? (
          <SubLink subLink={customerNo != 1158 ? t("vendor_group") : t("partner_group")} To="/vendor-group" />
        ) : null}
        {/* {this.props.permissions.TA_VENDOR_TYPE && this.props.permissions.TA_VENDOR_TYPE.VIEW == true ? ( */}
        <SubLink subLink={t("vehicle_type")} To="/vehicle-type" />
        {/* ) : (
                    null
                )} */}
        {this.props.permissions.TA_USER_MASTER &&
          this.props.permissions.TA_USER_MASTER.VIEW == true ? (
          <SubLink subLink={t("user")} To="/users" />
        ) : null}
        {/* {this.props.permissions.TA_DRIVER_MASTER && this.props.permissions.TA_DRIVER_MASTER.VIEW == true ? ( */}
        <SubLink subLink={t("driver")} To="/driver" />
        {/* ) : (
                    null
                )} */}
        {this.props.permissions.TA_CONSIGNOR_MASTER &&
          this.props.permissions.TA_CONSIGNOR_MASTER.VIEW == true ? (
          <SubLink subLink={t("consignor")} To="/consignor" />
        ) : null}
        {this.props.permissions.TA_CONSIGNEE_MASTER &&
          this.props.permissions.TA_CONSIGNEE_MASTER.VIEW == true ? (
          <SubLink subLink={t("consignee")} To="/consignee" />
        ) : null}
        {this.props.permissions.TA_CITY_MASTER &&
          this.props.permissions.TA_CITY_MASTER.VIEW == true ? (
          <SubLink subLink={t("city")} To="/city" />
        ) : null}
        {/* {this.props.permissions.TA_STATE_MASTER && this.props.permissions.TA_STATE_MASTER.VIEW == true ? (
                     <SubLink subLink={t("state")} To="/state" />
                ) : (
                    null
                )} */}
        {this.props.permissions.TA_ROUTE_MASTER &&
          this.props.permissions.TA_ROUTE_MASTER.VIEW == true ? (
          <SubLink subLink={t("route")} To="/route" />
        ) : null}
        {Number(localStorage.getItem("customerNumber")) == 1122 ? (null) : (
          <>
            {this.props.permissions.TA_ROUTE_MASTER &&
              this.props.permissions.TA_ROUTE_MASTER.VIEW == true ? (
              <SubLink subLink={t("billingParty")} To="/billingParty" />
            ) : null}
            {this.props.permissions.TA_USER_ROLE &&
              this.props.permissions.TA_USER_ROLE.VIEW == true ? (
              <SubLink subLink={t("branch")} To="/branch" />
            ) : null}
          </>
        )}

        {this.props.permissions.TA_SKU_MASTER &&
          this.props.permissions.TA_SKU_MASTER.VIEW == true ? (
          <SubLink subLink={t("product")} To="/product" />
        ) : null}
        {this.props.permissions.TA_SKU_MASTER &&
          this.props.permissions.TA_SKU_MASTER.VIEW == true ? (
          <SubLink subLink={t("product_type")} To="/productType" />
        ) : null}

        {this.props.permissions.TA_USER_ROLE &&
          this.props.permissions.TA_USER_ROLE.VIEW == true ? (
          <SubLink subLink={t("user_role")} To="/userrole" />
        ) : null}

       {FEATURES.shippingLineEnable && <SubLink subLink={t("shipping_line")} To="/shippingLine" />}
        {FEATURES.yardEnable && <SubLink subLink={t("yard")} To="/yard" />}
        {FEATURES.chaMasterEnable ?
          <SubLink subLink={t("CHA")} To="/cha" />
          : null}

      <SubLink subLink={t("zone")} To="/zone" />
      <SubLink subLink={t("bank")} To="/bank" />
      </div>
    );

    const Reports = (
      <div>
        {/* <SubLink subLink={t("Dump Analysis")} To="/reportsheet" /> */}


        {Number(localStorage.getItem("customerNumber")) == 1158 || Number(localStorage.getItem("customerNumber")) == 1123 ?
          <>
            <SubLink subLink={t("Order Placement Ratio")} To="/order-placement-ratio" />
            <SubLink subLink={t("In-Transit Vehicles")} To="/in-transit-vehicles" />
            {Number(localStorage.getItem("customerNumber")) == 1158 ?
              <>
                <SubLink subLink={t("Offer Vs Final Price")} To="/reportsheet?OFFER_VS_FINAL_PRICE" type="OFFER_VS_FINAL_PRICE" />
                <SubLink subLink={t("Partner Performance Dashboard")} To="/reportsheet?PARTNER_PERFORMANCE_DASHBOARD" type='PARTNER_PERFORMANCE_DASHBOARD' />
                <SubLink subLink={t("THC Report")} To="/reportsheet?THC_DASHBOARD" type='THC_DASHBOARD' />
              </>
              :
              null}
            {Number(localStorage.getItem("customerNumber")) == 1123 ?
              <>
                <SubLink subLink={t("On Time Placement Analysis")} To="/reportsheet?ON_TIME_PLACEMENT_ANALYSIS" type="ON_TIME_PLACEMENT_ANALYSIS" />
                <SubLink subLink={t("Vendor Allocation Status")} To="/reportsheet?VENDOR_ALLOCATION_STATUS" type="VENDOR_ALLOCATION_STATUS" />
              </>
              :
              null}
          </>
          : null
        }
        {FEATURES.performanceEffireincyReport || FEATURES.ordersReport || FEATURES.user_login_history ?
          <>
            <SubLink subLink={reportTitle.PERFORMANCE_EFFICIENCY} To="/reportsheet?PERFORMANCE_EFFICIENCY" type="PERFORMANCE_EFFICIENCY" />
            <SubLink subLink={reportTitle.ORDERS_REPORT} To="/reportsheet?ORDERS_REPORT" type="ORDERS_REPORT" />
            <SubLink subLink={reportTitle.USER_LOGIN_HISTORY} To="/reportsheet?USER_LOGIN_HISTORY" type="USER_LOGIN_HISTORY" />
          </>
          :
          null}

        {isMISReportEnabled ?
          <>
            <SubLink subLink={reportTitle.MIS_REPORT} To="/reportsheet?MIS_REPORT" type="MIS_REPORT" />
          </>
          : null
        }

        {isLRDumpReportEnabled ?
          <>
            <SubLink subLink={reportTitle.LR_DUMP} To="/reportsheet?LR_DUMP_REPORT" type="LR_DUMP_REPORT" />
          </>
          : null
        }

        {isPlacementAnalysisReportEnabled ?
          <>
            <SubLink subLink={reportTitle.PLACEMENT_ANALYSIS} To="/reportsheet?PLACEMENT_ANALYSIS" type="PLACEMENT_ANALYSIS" />
          </>
          : null
        }

        {isTripDistanceAnalysisReportEnabled ?
          <>
            <SubLink subLink={t("Trip Distance Analysis")} To="/reportsheet?TRIP_DISTANCE_ANALYSIS" type="TRIP_DISTANCE_ANALYSIS" />
          </>
          : null
        }
        { isDumpAnalysisReportEnabled  ?
          <>
            <SubLink subLink={t("Dump Analysis")} To="/reportsheet?DUMP_ANALYSIS" type="DUMP_ANALYSIS" />
          </>
          : null
        }

        {dailyPlacementDashboard ?
          <>
            <SubLink subLink={reportNames.DAILY_PLACEMENT_DASHBOARD} To="/reportsheet?DAILY_PLACEMENT_DASHBOARD" type="DAILY_PLACEMENT" />
          </>
          : null
        }
        {SOBReport ?
        <>
        <SubLink subLink={t("SOB Report")} To="/sob-report" />
        </>
        : null
        }
        {
          isLrProfitabilityReportEnabled?
            <>
            <SubLink subLink={t("lr_profitablility_report")} To="/reportsheet?LR_PROFITABILITY_REPORT" type='LR_PROFITABILITY_REPORT' />
            
            </>
            : null
        }
        {FEATURES.dumpDashboardEnabled ?
          <>
            <SubLink subLink={reportTitle.DUMP_DASHBOARD} To="/reportsheet?DUMP_DASHBOARD" type="DUMP_DASHBOARD" />
          </>
          : null
        }
        {FEATURES.rateEngineExceptionReportEnabled ?
          <>
            <SubLink subLink={reportTitle.RATE_ENGINE_EXCEPTION_REPORT} To="/reportsheet?RATE_ENGINE_EXCEPTION_REPORT" type="RATE_ENGINE_EXCEPTION_REPORT" />
          </>
          : null
        }
      </div>


    );

    return (
      <Accordion
        as={Menu}
        vertical
        style={{ backgroundColor: "#2D373C", width: "100%" }}
      >
        {this.props?.permissions?.TA_OVERALL_MASTER?.VIEW == true ?
          <Menu.Item className="mb-3 accordionStyle">
            <Accordion.Title
              className="w3-text-white w3-small"
              active={activeIndex === 1}
              content={
                <div className="nav-link p-hover p-3 w3-text-white checklink stylefont">
                  <img
                    className="ml-2"
                    src="assets/svg/master.svg"
                    alt="Masters"
                    width="18"
                  />
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;{t("master")}</span>
                </div>
              }
              index={1}
              onClick={this.handleClick}
            />
            <Accordion.Content active={activeIndex === 1} content={Masters} />
          </Menu.Item>
          : null}

        {this.props?.permissions?.TA_REPORTS?.VIEW == true ?
        <Menu.Item className="mb-3 accordionStyle">
          <Accordion.Title
            className="w3-text-white w3-small mb-1"
            active={activeIndex === 2}
            content={<div className="nav-link p-hover p-3 w3-text-white checklink stylefont">
              <img className="ml-2" src="assets/svg/report.svg" alt="Masters" width="18" />
              <span>&nbsp;&nbsp;&nbsp;&nbsp;{t("report")}</span>
            </div>}
            index={2}
            onClick={this.handleClick}

          />

          {isReportsEnabled ? <Accordion.Content active={activeIndex === 2} content={Reports} /> : ''}
        </Menu.Item>:null}
      </Accordion>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  };
};
export default connect(mapStateToProps)(
  translate("sidebar")(AccordionExampleMenu)
);
